<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.3409 4.88514C14.9186 3.89884 14.3527 3.04909 13.6431 2.33623C12.9339 1.6233 12.0857 1.05558 11.0993 0.633362C10.1133 0.211145 9.07994 0 8.00025 0C6.92045 0 5.88731 0.211254 4.90093 0.633362C3.91452 1.05558 3.06656 1.62319 2.35712 2.33623C1.64764 3.04909 1.08167 3.89884 0.659449 4.88514C0.237268 5.87151 0.026123 6.90814 0.026123 7.99478C0.026123 9.08145 0.237268 10.1198 0.659449 11.1095C1.08178 12.0995 1.6476 12.9507 2.35712 13.6638C3.06656 14.3767 3.91452 14.9445 4.90093 15.3664C5.88731 15.7888 6.92041 16 8.00025 16C9.08008 16 10.1133 15.7888 11.0993 15.3664C12.0857 14.9443 12.9339 14.3767 13.6431 13.6638C14.3527 12.9507 14.9186 12.0995 15.3409 11.1095C15.7632 10.1197 15.9741 9.08142 15.9741 7.99478C15.974 6.90814 15.7632 5.87151 15.3409 4.88514ZM3.27596 11.099C2.65991 10.1511 2.35188 9.11589 2.35203 7.99464C2.35203 6.97029 2.60474 6.022 3.11002 5.14978C3.61519 4.27763 4.30059 3.58896 5.16572 3.0835C6.03092 2.57822 6.97576 2.32565 8.00025 2.32565C9.14256 2.32565 10.1805 2.64062 11.1151 3.27049L3.27596 11.099ZM13.2017 10.2013C12.904 10.9038 12.5028 11.5078 11.9975 12.0132C11.492 12.5185 10.8916 12.9217 10.1959 13.2225C9.50023 13.5235 8.7682 13.6742 8.00003 13.6742C6.89259 13.6742 5.86469 13.3664 4.91635 12.7501L12.7451 4.93176C13.3476 5.85929 13.6484 6.88032 13.6484 7.99467C13.6482 8.7631 13.4994 9.49851 13.2017 10.2013Z"
      fill="#EA3C53"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
